// extracted by css-extract-rspack-plugin
export default {"spaceMedium":"20px","sizeFluid":"100%","container":"home-byod-viewer__container___GNmu7","loadingContainer":"home-byod-viewer__loadingContainer___mEaKP"};